import _export from '../internals/export.js';
import functionApply$1 from '../internals/function-apply.js';
import aCallable$1 from '../internals/a-callable.js';
import anObject$1 from '../internals/an-object.js';
import fails$1 from '../internals/fails.js';

var $ = _export;
var functionApply = functionApply$1;
var aCallable = aCallable$1;
var anObject = anObject$1;
var fails = fails$1; // MS Edge argumentsList argument is optional

var OPTIONAL_ARGUMENTS_LIST = !fails(function () {
  // eslint-disable-next-line es/no-reflect -- required for testing
  Reflect.apply(function () {
    /* empty */
  });
}); // `Reflect.apply` method
// https://tc39.es/ecma262/#sec-reflect.apply

$({
  target: 'Reflect',
  stat: true,
  forced: OPTIONAL_ARGUMENTS_LIST
}, {
  apply: function apply(target, thisArgument, argumentsList) {
    return functionApply(aCallable(target), thisArgument, anObject(argumentsList));
  }
});
